import React, { useState } from 'react'
import { Grid, IconButton, LinearProgress, TextField as MuiTextField } from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'
import { Autocomplete } from '@material-ui/lab'
import { useDebouncedCallback } from 'use-debounce'

import { Base } from 'src/api/models'
import { useQueryPaginator } from 'src/components/Table'
import { FilterProps } from './types'

export const createMultiQuerySelectFilter = (fetch: () => any) => {
  const MultiQuerySelectFilter = (props: FilterProps) => {
    const { label, defaultValue, onChange } = props
    const [selections, setSelections] = useState<Base[]>(defaultValue || [])
    const paginator = useQueryPaginator(
      `${label}-filter`,
      fetch
    )
    const dePaginatorFilters = useDebouncedCallback(paginator.patchFilters, 100)
    return (
      <Grid container>
        <Grid item xs={12}>
          <Autocomplete
            id={label}
            options={paginator.data.results}
            getOptionLabel={(obj: Base) => obj.name}
            getOptionSelected={(option, value) => option.guid === value?.guid}
            filterOptions={(option) => option}
            onChange={(_: any, newValue: any) => {
              const newValueList = [...selections, newValue]
              setSelections(newValueList)
              onChange(newValueList, (newValueList.map((v) => v.guid).join(',')))
            }}
            value={null}
            renderInput={(params) => (
              <>
                <MuiTextField
                  {...params}
                  label={paginator.loading ? 'Loading...' : label}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    dePaginatorFilters.callback({ search: event.target.value })
                  }
                />
                {paginator.loading && <LinearProgress />}
              </>
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            {selections?.map((obj: Base) => {
              if (obj) {
                return (
                  <React.Fragment key={obj.guid}>
                    <Grid item><span>{obj.name}</span></Grid>
                    <Grid item>
                      <IconButton
                        color="primary"
                        onClick={() => {
                          const newValueList = selections.filter((v: Base) => v.guid !== obj.guid)
                          setSelections(newValueList)
                          onChange(newValueList, (newValueList.map((v) => v.guid).join(',')))
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Grid>
                  </React.Fragment>
                )
              }
            })}
          </Grid>
        </Grid>
      </Grid>
    )
  }
  return MultiQuerySelectFilter
}
